export default __webpack_public_path__ + "4a2a405d77a8a1656e172e0278a5fa4c.png";